import React from 'react'
import fullscreen from 'fullscreen'

export default class Fullscreen extends React.PureComponent {
	
	constructor( props ) {
		
		super(props)
		this.state = {
			fullscreenAvailable: fullscreen.available()
		}
		
		this.onFullscreenAttain = this.onFullscreenAttain.bind(this)
		this.onFullscreenRelease = this.onFullscreenRelease.bind(this)
		this.onFullscreenError = this.onFullscreenError.bind(this)
		
		this.toggleFullscreen = this.toggleFullscreen.bind(this)
	}
	
	componentDidMount() {
		
		this.fullscreen = fullscreen(this.ref)
		
		this.onFullscreenAttain = this.onFullscreenAttain.bind(this)
		this.onFullscreenRelease = this.onFullscreenRelease.bind(this)
		this.onFullscreenError = this.onFullscreenError.bind(this)
		
		this.setState({
			fullscreenAvailable: fullscreen.available()
		})
		
	}
	
	componentWillUnmount() {
		
		window.removeEventListener('fullscreenchange', this.onWindowFullscreenChange)
		this.fullscreen.dispose()
		
	}
	
	toggleFullscreen() {
		
		if (!this.fullscreen.target()) {
			this.requestFullscreen()
		} else {
			this.fullscreen.release()
		}
		
	}

	requestFullscreen() {
		
		this.fullscreen.on('attain', this.onFullscreenAttain)
		this.fullscreen.on('error', this.onFullscreenError)
		this.fullscreen.request()
		
	}
	
	onFullscreenAttain() {
		
		this.setState({
			isFullscreen: true
		})
		
		if ( this.props.onFullscreenChange ) {
			this.props.onFullscreenChange( true )
		}
		
		this.fullscreen.on('release', this.onFullscreenRelease)
		this.fullscreen.removeAllListeners('error')
		this.fullscreen.removeAllListeners('attain')
		
	}

	onFullscreenRelease() {
		
		this.setState({
			isFullscreen: false
		})
		
		if ( this.props.onFullscreenChange ) {
			this.props.onFullscreenChange( false )
		}
		
		this.fullscreen.removeAllListeners('release')
		this.fullscreen.removeAllListeners('error')
	}

	onFullscreenError() {
		
		this.fullscreen.removeAllListeners('error')
		
	}
	
	render() {
		
		var child = React.cloneElement(this.props.children,
			Object.assign({}, this.props, {
				toggleFullscreen: this.toggleFullscreen,
				fullscreenAvailable: this.state.fullscreenAvailable,
				isFullscreen: this.state.isFullscreen
			})
		)
		
		return (
			<div ref={ ref => this.ref = ref }>
				{ child }
			</div>
		)
		
	}
}


// WEBPACK FOOTER //
// ./src/components/fullscreen/Fullscreen.jsx